import { AnimatePresence, motion } from 'framer-motion';
import { useRef } from 'react';

import { colors } from '@tempmee/tailwind';
import { useFixedWidth } from '../../hooks/useFixedWidth';
import { useFixedAlignment } from '../../hooks/useFixedAlignment';
import { ConfirmOrDecline } from '../ConfirmOrDecline';
import { SolidStarIcon } from '@tempmee/react-icons';

export const CollapsibleCandidateHeader = ({
  candidate,
  job,
  currentCounter,
  allCandidates,
  notesForTemp,
  show,
  allowNavigation,
  onDeclineConfirmed,
  onConfirmOutcome,
  onConfirmPendingChange,
  onDeclinePendingChange,
  onDeclineSuccess,
  onPaymentMissing,
}) => {
  const parentRef = useRef(null);
  const fixedWidth = useFixedWidth(parentRef);
  const leftOffset = useFixedAlignment(parentRef);
  const hasMultipleCounters = allCandidates?.length > 1;

  return (
    <div
      ref={parentRef}
      style={{
        position: 'relative',
      }}
    >
      <AnimatePresence>
        {show && (
          <motion.div
            style={{
              position: 'fixed',
              width: fixedWidth,
              left: leftOffset,
              top: hasMultipleCounters ? 133 : 64,
              zIndex: 10,
              backgroundColor: colors.shades[0],
              boxShadow:
                '0px 3px 10px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
            }}
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: show ? 1 : 0, y: 0 }}
            exit={{ opacity: 0, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div
              style={{
                position: 'sticky',
                top: 400,
                zIndex: 10,
                backgroundColor: colors.shades[0],
              }}
            >
              <div
                style={{
                  height: 64,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  paddingLeft: 40,
                  paddingRight: 80,
                  backgroundColor: colors.shades[0],
                }}
              >
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ marginLeft: 20 }}>
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          <b
                            style={{
                              fontSize: 20,
                              color: colors.neutral[600],
                              fontFamily: 'Nunito',
                              margin: '0px 7px 0px 0px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: 400,
                            }}
                          >
                            {`${candidate?.first_name} ${candidate?.last_name}`}
                          </b>

                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <SolidStarIcon size={20} color={colors.success[500]} />
                            <b
                              style={{
                                fontSize: 16,
                                marginRight: 5,
                                color: colors.neutral[600],
                                fontFamily: 'Nunito',
                              }}
                            >
                              {candidate?.average_rating?.toFixed(1) || '5.0'}
                            </b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ConfirmOrDecline
                  candidateId={candidate?.id}
                  job={job}
                  currentCounter={currentCounter}
                  allCandidates={allCandidates}
                  notesForTemp={notesForTemp}
                  allowNavigation={allowNavigation}
                  onDeclineConfirmed={onDeclineConfirmed}
                  onConfirmOutcome={onConfirmOutcome}
                  onConfirmPendingChange={onConfirmPendingChange}
                  onDeclinePendingChange={onDeclinePendingChange}
                  onDeclineSuccess={onDeclineSuccess}
                  onPaymentMissing={onPaymentMissing}
                  small
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
